import { useModal as useModalNext } from 'src/shared/modalProvider';

/**
 * @deprecated import { useModal } from 'src/shared/modalProvider';
 */
export const useModal = useModalNext;
